import { render, staticRenderFns } from "./practitioners-menu.vue?vue&type=template&id=349f63ae&"
import script from "./practitioners-menu.vue?vue&type=script&lang=ts&"
export * from "./practitioners-menu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports